import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
function ScenarioEditor({ projectId }) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [steps, setSteps] = useState([{ location: '', description: '', reference: '' }]);
  const handleChange = (index, field, value) => {
    const updated = [...steps];
    updated[index][field] = value;
    setSteps(updated);
  };

  const handleAddStep = () => {
    setSteps([...steps, { location: '', description: '', reference: '' }]);
  };

  const handleSave = async () => {
    const payload = { title, description, steps: JSON.stringify(steps), project_id: projectId };
    const res = await fetch(`http://localhost:3001/projects/${projectId}/scenario`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    alert('📌 Scénario enregistré !');
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-3">🎥 Écrire un Scénario pour le Projet</h2>
      <input className="form-control mb-3" placeholder="Titre" value={title} onChange={(e) => setTitle(e.target.value)} />
      <textarea className="form-control mb-3" placeholder="Description globale" value={description} onChange={(e) => setDescription(e.target.value)} rows={3} />

      <h5>🌍 Étapes du Scénario</h5>
      {steps.map((step, i) => (
        <div key={i} className="border p-3 rounded mb-2">
          <input className="form-control mb-2" placeholder="Lieu" value={step.location} onChange={(e) => handleChange(i, 'location', e.target.value)} />
          <textarea className="form-control mb-2" placeholder="Description" rows={2} value={step.description} onChange={(e) => handleChange(i, 'description', e.target.value)} />
          <input className="form-control" placeholder="Lien (vidéo ou article)" value={step.reference} onChange={(e) => handleChange(i, 'reference', e.target.value)} />
        </div>
      ))}
      <button className="btn btn-outline-primary me-2" onClick={handleAddStep}>➕ Ajouter une étape</button>
      <button className="btn btn-success" onClick={handleSave}>💾 Enregistrer</button>
    </div>
  );
}

export default ScenarioEditor;
